import { useEffect } from "react";

/**
 * Hook reutilizable: ejecuta `onEscape` cuando el usuario presiona Esc.
 *
 * @param {boolean} enabled - Solo activo si es true (usalo con `open`).
 * @param {() => void} onEscape - Callback al presionar Esc.
 */
export function useEscapeKey(enabled, onEscape) {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onEscape?.();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [enabled, onEscape]);
}
